import { BASE_URL } from 'config';
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";


import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { useEffect, useState } from "react";
import axios from "axios";
import StoreCard from 'components/top-seles-stores-card/store-card';
import TopSellingStoresHeader from '../../components/top-seles-stores-card/top-seller-header';
import { Box } from '@mui/material';

function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Fetch statistics data
    const fetchDashboard = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("user-token");
        const res = await axios.get(
          BASE_URL + "/administrator/dashboard",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDashboardData(res.data.data);
      } catch (err) {
        // Handle error if needed
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);
  const { sales, tasks } = reportsLineChartData;

  if (loading) {
    return (
      <>
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress color="text" />
        </MDBox>
      </>
    );
  }

  return (
    <>
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="Inventory"
                title="الطلبات"
                count={dashboardData?.orders_count}
                percentage={{
                  color: "success",
                  amount: "+55%",
                  label: "الاسبوع الماضي",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="اجمالي المبيعات"
                count={dashboardData?.sales_total}
                percentage={{
                  color: "success",
                  amount: "+3%",
                  label: "هذا الشهر",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="اجمالي المتاجر"
                count={dashboardData?.stores_count}
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="اجمالي المستخدمين"
                count={dashboardData?.users_count}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="person"
                title="اجمالي العملاء"
                count={dashboardData?.customers_count}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="store"
                title="متاجر جديدة"
                count={dashboardData?.new_stores}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "في انتظار الموافقة",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Box sx={{ marginBlock: 4.5 }}>

          <TopSellingStoresHeader />
          <Grid container spacing={3}>
            {dashboardData?.top_selling_stores.map((store) => (
              <Grid item size={{ xs: 12, md: 6, lg: 3 }} key={store.id}>
                <StoreCard store={store} />
              </Grid>
            ))}
          </Grid>
        </Box>

        <OrdersOverview top_selling_products={dashboardData?.top_selling_products} />

      </MDBox>

      <Footer />
    </>
  );
}

export default Dashboard;
